import { Outlet } from "react-router-dom";

import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

import styles from './AuthLayout.module.css';

export const AuthLayout = () => {

    return (
        <>
            {/* Navbar */}
            <Navbar />
            {/* Navbar */}
            <div className={"container " + styles.authContainer}>
                <div className="row">
                    <div className="col">
                        <div className={styles.formContainer}>
                            <div className={styles.outletContainer}>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <Footer />    
            {/* Footer */}
        </>
    )
}
